module.exports = __webpack_public_path__ + "static/img_1006-3a28333299a80c68d03012afde3dbefb.webp";